import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NewTransferComponent } from './transfers/new-transfer.component';
import { AuthComponent } from './auth/auth.component';
import { AuthCallbackComponent } from './auth/auth-callback.component';
import { AuthSignOutComponent } from './auth/auth-sign-out.component';
import { DownloadsComponent } from './downloads/downloads.component';
import { AuthGuard } from './auth/auth-guard.service'
import { HistoryComponent } from './history/history.component';
import { LayoutComponent } from './layouts/layout.component';
import { SimpleLayoutComponent } from './layouts/simple-layout.component';
import { DownloadComponent } from './downloads/download.component';
import { RootGuard } from './root-guard.service';
import { UnsavedGuard } from './transfers/unsaved-guard.service';
import { ActiveSessionsComponent } from './auth/active-sessions.component';
import { QCDashboardComponent } from './qc/qc-dashboard.component';
import { RootComponent } from './root/root.component';
import { SettingsComponent } from './users/settings.component';
import { AsperaDesktopMigrationComponent } from './help/aspera-desktop-migration/aspera-desktop-migration.component';

const appRoutes: Routes = [
  {path: '', canActivate: [RootGuard], pathMatch: 'full',
    component: SimpleLayoutComponent, children: [
      {path: '', component: AuthComponent}
  ]},
  {path: 'auth', component: SimpleLayoutComponent, children: [
    {path: '', component: AuthComponent},
    {path: 'signout', component: AuthSignOutComponent}
  ]},
  {path: 'auth/callback', component: AuthCallbackComponent},
  {path: '', canActivate: [AuthGuard], component: LayoutComponent, children: [
    {path: 'auth/sessions', component: ActiveSessionsComponent},
    {path: 'downloads', component: DownloadsComponent},
    {path: 'downloads/:id', component: DownloadComponent},
    {path: 'history', component: HistoryComponent},
    {path: 'home', component: NewTransferComponent, canDeactivate: [UnsavedGuard]},
    {path: 'qc_reports', component: QCDashboardComponent},
    {path: 'root', component: RootComponent},
    {path: 'users/settings', component: SettingsComponent},
    {path: 'help/aspera-desktop-migration', component: AsperaDesktopMigrationComponent},
  ]}
]

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
  providers: [
    AuthGuard,
    RootGuard
  ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts